var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/active-item.png": "b7ac",
	"./assets/base-musicbox.png": "e4b3",
	"./assets/bg.png": "d68e",
	"./assets/changedisc.png": "8f84",
	"./assets/close.png": "cd5c",
	"./assets/fz.png": "617c",
	"./assets/handler-bg.png": "ce30",
	"./assets/img/audition/bg.png": "33c5",
	"./assets/img/audition/bg1.png": "4d03",
	"./assets/img/audition/listen.png": "34fd",
	"./assets/img/bg.png": "dc97",
	"./assets/img/draw/box.png": "3fec",
	"./assets/img/draw/btn.png": "8137",
	"./assets/img/draw/pause.png": "6795",
	"./assets/img/draw/play.png": "6cb5",
	"./assets/img/draw/text.png": "60f4",
	"./assets/img/draw/title.png": "9a16",
	"./assets/img/home/bg.png": "2de1",
	"./assets/img/music-icon.png": "56f1",
	"./assets/img/phonograph/bg-box01.png": "b3b9",
	"./assets/img/phonograph/bg-box02.png": "073c",
	"./assets/img/phonograph/bg.jpg": "4d8e",
	"./assets/img/phonograph/btn01.png": "14e5",
	"./assets/img/phonograph/btn1.png": "e03c",
	"./assets/img/phonograph/card01.png": "2671",
	"./assets/img/phonograph/cd01.png": "82df",
	"./assets/img/phonograph/cd02-mask.png": "985c",
	"./assets/img/phonograph/cd02.png": "ff1d",
	"./assets/img/phonograph/gen-poster.png": "c88f",
	"./assets/img/phonograph/text01.png": "68d9",
	"./assets/img/share-bg.png": "9082",
	"./assets/img/share.png": "cff1",
	"./assets/img/sprites.png": "c618",
	"./assets/m-icon.png": "99ee",
	"./assets/m-item1.png": "a463",
	"./assets/m-item2.png": "a0c8",
	"./assets/m-item3.png": "8811",
	"./assets/m-item4.png": "0f29",
	"./assets/musicbox-arm.png": "f085",
	"./assets/musicbox-slot.png": "6014",
	"./assets/musicbox.png": "d3b1",
	"./assets/nc-bg.png": "c2f2",
	"./assets/noactive-item.png": "5194",
	"./assets/open-act-btn.png": "e7cc",
	"./assets/open-more.png": "c3e0",
	"./assets/scroll-bg1.png": "be6d",
	"./assets/scroll-bg2.png": "630b",
	"./assets/scroll-bg3.png": "9f1a",
	"./assets/scroll-bg4.png": "0652",
	"./assets/sd.png": "5e65",
	"./assets/sg.png": "e2fc",
	"./assets/share-qq.png": "8af3",
	"./assets/share-qzone.png": "6c5e",
	"./assets/share-wechat-hy.png": "f213",
	"./assets/share-wechat-pyq.png": "8091",
	"./assets/share-weibo.png": "63f1",
	"./assets/to-draw-page.png": "81e1",
	"./assets/to-draw.png": "67ea",
	"./assets/tonext.png": "b22f",
	"./assets/topaused.png": "5877",
	"./assets/toplay.png": "4323",
	"./assets/topre.png": "d2bf",
	"./assets/touch.png": "10f7",
	"./assets/方正颜宋简体.TTF": "53bf",
	"./assets/方正颜宋简体_粗.TTF": "bec9",
	"./components/AudioPlayer": "7901",
	"./components/AudioPlayer.vue": "7901",
	"./components/Loading": "3a5e",
	"./components/Loading.vue": "3a5e",
	"./components/MusicIcon": "c28b",
	"./components/MusicIcon.vue": "c28b",
	"./components/MusicListShow": "e83c",
	"./components/MusicListShow.vue": "e83c",
	"./components/Poster": "e4bb",
	"./components/Poster.vue": "e4bb",
	"./components/PosterGenerator": "a307",
	"./components/PosterGenerator.vue": "a307",
	"./components/ScrollBarItem": "806c",
	"./components/ScrollBarItem.vue": "806c",
	"./components/Scrollbar": "090a",
	"./components/Scrollbar.vue": "090a",
	"./components/Share": "17a4",
	"./components/Share.vue": "17a4",
	"./components/ShareBar": "e310",
	"./components/ShareBar/": "e310",
	"./components/ShareBar/index": "e310",
	"./components/ShareBar/index.vue": "e310",
	"./less/function.less": "05ac",
	"./less/reset.css": "d8bc",
	"./less/reset.less": "c253",
	"./main": "56d7",
	"./main.js": "56d7",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./service/apiTime": "d637",
	"./service/apiTime.js": "d637",
	"./service/jsonp": "31fa",
	"./service/jsonp.js": "31fa",
	"./service/services": "43ea",
	"./service/services.js": "43ea",
	"./store": "4360",
	"./store/": "4360",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./utils/callApp": "97b8",
	"./utils/callApp.js": "97b8",
	"./utils/rem": "4942",
	"./utils/rem.js": "4942",
	"./utils/report": "0a57",
	"./utils/report.js": "0a57",
	"./utils/tools": "b893",
	"./utils/tools.js": "b893",
	"./utils/utils": "fa7d",
	"./utils/utils.js": "fa7d",
	"./views/Album": "724d",
	"./views/Album/": "724d",
	"./views/Album/constants": "7961",
	"./views/Album/constants.js": "7961",
	"./views/Album/index": "724d",
	"./views/Album/index.vue": "724d",
	"./views/Audition": "785f",
	"./views/Audition/": "785f",
	"./views/Audition/index": "785f",
	"./views/Audition/index.vue": "785f",
	"./views/Draw": "0f4f",
	"./views/Draw/": "0f4f",
	"./views/Draw/constant": "254a",
	"./views/Draw/constant.js": "254a",
	"./views/Draw/index": "0f4f",
	"./views/Draw/index.vue": "0f4f",
	"./views/Home": "16c0",
	"./views/Home/": "16c0",
	"./views/Home/index": "16c0",
	"./views/Home/index.vue": "16c0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";